export enum ProfileStrength {
  LOW = "low",
  MODERATE = "moderate",
  STRONG = "strong",
}

export interface MemberStats {
  docsCount: number;
  remindersCount: number;
  memoriesCount: number;
  emergencyCardReady: boolean;
  emergencyCardComplete: boolean;
  healthSummaryReady: boolean;
  labInsightsReady: boolean;
  healthProfileComplete: boolean;
  insuranceAdded: boolean;
  vitalsAdded: boolean;
  profileScore: number;
  profileStrength: ProfileStrength;
}

export interface FamilyStats {
  familyId: string;
  totalDocs: number;
  totalReminders: number;
  totalHealthMemories: number;
  totalEmergencyCardReady: number;
  totalHealthSummaryReady: number;
  totalHealthProfileCompleted: number;
  memberStats: { [memberId: string]: MemberStats };
}

export interface UpdateMemberStatsDto {
  memberId: string;
  docsCount?: number;
  remindersCount?: number;
  memoriesCount?: number;
  emergencyCardReady?: boolean;
  healthSummaryReady?: boolean;
  labInsightsReady?: boolean;
  healthProfileComplete?: boolean;
  insuranceAdded?: boolean;
  vitalsAdded?: boolean;
  profileScore?: number;
  profileStrength?: ProfileStrength;
}
